import { useEffect, useState } from 'react';
import { NotFound } from '../../../components/NotFound';
import { useAuth } from '../../../contexts/AuthProvider';
import { AccountLedgerModel, fetctAccountLedger } from '../../../model/account.model';
import { formatDate, numberDisplay, parseFixed, toDrCr } from '../../../services/formats';
import { Table } from 'react-bootstrap';
import { useUtility } from '../../../contexts/UtilityContext';

interface IOwnProps {
  id?: number;
  searchParams?: any;
}

export default function AccountLedger({ id, searchParams }: IOwnProps) {
  const { isLoading, showLoader, hideLoader } = useUtility();
  const [list, setList] = useState<Array<AccountLedgerModel>>([]);
  const [summary, setSummary] = useState({
    credit: 0,
    debit: 0,
  });
  const { authInfo } = useAuth();

  useEffect(() => {
    async function fetchData() {
      if (id) {
        try {
          showLoader();
          const res = await fetctAccountLedger({ id, ...searchParams }, authInfo);
          setList(res.data.map((item, index) => {
            if (index === 0) {
              item.balance = item.debit - item.credit;
            } else {
              item.balance = res.data[index - 1].balance + (item.debit - item.credit);
            }
            return item;
          }));
          setSummary(prev => ({
            ...prev,
            credit: res.data.reduce((acc, item) => acc + parseFixed(item.credit), 0),
            debit: res.data.reduce((acc, item) => acc + parseFixed(item.debit), 0),
          }));
        } catch (err) {
          alert(err);
        } finally {
          hideLoader();
        }
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authInfo, id]);

  return (
    <>
      {!isLoading && list.length === 0 ? <NotFound /> : <Table striped bordered hover responsive width="100%">
        <thead>
          <tr>
            <th className='text-center'>DATE</th>
            <th className='text-center'>NARRATION</th>
            <th className='text-center'>BILTY</th>
            <th className='text-center'>REMARKS</th>
            <th className='text-center'>DEBIT</th>
            <th className='text-center'>CREDIT</th>
            <th className='text-center'>BALANCE</th>
          </tr>
        </thead>
        <tbody>
          {list.map((item, index) => (
            <tr key={`account-ledger-${index}`}>
              <td className='text-center'>{formatDate(item.v_date)}</td>
              <td>{item.narration}</td>
              <td>{item.bilty_no}</td>
              <td>{item.remarks}</td>
              <td className='text-end'>{numberDisplay(item.debit)}</td>
              <td className='text-end'>{numberDisplay(item.credit)}</td>
              <td className='text-end'>{toDrCr(item.balance)}</td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr>
            <th colSpan={4} className='text-end'>SUB TOTAL</th>
            <th className='text-end'>{numberDisplay(summary.debit)}</th>
            <th className='text-end'>{numberDisplay(summary.credit)}</th>
            <th className='text-end'>{toDrCr(summary.debit - summary.credit)}</th>
          </tr>
        </tfoot>
      </Table>
      }
    </>
  );
};